// API取得用のユーティリティ関数
import {
  MASTER_DATA_URLS,
  getFrameworkLibraryUrl,
  getBusinessSystemProductLanguageUrl,
  getCloudServiceProductUrl,
  getServerEnvironmentUrl,
  getMiddlewareProductUrl
} from '../config/masterDataUrls';

/**
 * ステップ1-18のマスタデータを取得する
 * @param {string} dataType - 取得するデータタイプ
 * @returns {Promise<Array>} 取得したデータ
 */
export const fetchMasterData = async (dataType) => {
  try {
    const url = MASTER_DATA_URLS[dataType];

    if (!url) {
      if (dataType === 'fw_libraries') {
        return [];
      }
      console.warn(`Unknown data type: ${dataType}`);
      return [];
    }

    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching ${dataType}:`, error);
    return [];
  }
};

/**
 * ステップ8-9のフレームワーク・ライブラリのマスタデータを取得する（フロントエンド・バックエンド両対応）
 * @param {string} languageName - 言語名
 * @param {string} languageType - 言語タイプ（'front_end' | 'back_end'）
 * @returns {Promise<Array>} フレームワーク・ライブラリデータ
 */
export const fetchFrameworkData = async (languageName, languageType = 'front_end') => {
  try {
    const url = getFrameworkLibraryUrl(languageName, languageType);
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching framework data:', error);
    return [];
  }
};

/**
 * ステップ10の業務システムの製品/言語データを取得する
 * @param {string} businessSystemName - 業務システム名
 * @returns {Promise<Array>} 製品/言語データ
 */
export const fetchBusinessSystemProductLanguageData = async (businessSystemName) => {
  try {
    const url = getBusinessSystemProductLanguageUrl(businessSystemName);
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching business system product language data:', error);
    return [];
  }
};

/**
 * ステップ11のクラウドサービスの製品データを取得する
 * @param {string} cloudServiceName - クラウドサービス名
 * @returns {Promise<Array>} 製品データ
 */
export const fetchCloudServiceProductData = async (cloudServiceName) => {
  try {
    const url = getCloudServiceProductUrl(cloudServiceName);
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching cloud service product data:', error);
    return [];
  }
};

/**
 * ステップ12のサーバー環境データを取得する
 * @param {string} serverOperatingSystemName - サーバーOS名
 * @returns {Promise<Array>} サーバー環境データ
 */
export const fetchServerEnvironmentData = async (serverOperatingSystemName) => {
  try {
    const url = getServerEnvironmentUrl(serverOperatingSystemName);
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching server environment data:', error);
    return [];
  }
};

/**
 * ステップ13のミドルウェア製品データを取得する
 * @param {string} middlewareName - ミドルウェア名
 * @returns {Promise<Array>} 製品データ
 */
export const fetchMiddlewareProductData = async (middlewareName) => {
  try {
    const url = getMiddlewareProductUrl(middlewareName);
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching middleware product data:', error);
    return [];
  }
};
